export const getOperationalReportTypeFrag = `
    id
    key
`;
